import React from 'react';
import GridContainer from '../../../../@jumbo/components/GridContainer';
import PageContainer from '../../../../@jumbo/components/PageComponents/layouts/PageContainer';
import IntlMessages from '../../../../@jumbo/utils/IntlMessages';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import TablaReclamosTodos from './Tabla';

const breadcrumbs = [
  { label: <IntlMessages id={'sidebar.main'} />, link: '/' },
  { label: <IntlMessages id={'pages.analista.reclamos'} />, isActive: true },
];

const Reclamos = () => {
  return (
    <PageContainer heading={<IntlMessages id="pages.analista.reclamos" />} breadcrumbs={breadcrumbs}>
      <GridContainer>
        <Grid item xs={12}>
          {/* <div style={{ marginBottom: 10 }}>
            <IntlMessages id="pages.analista.reclamos" />
          </div> */}
          <Divider />
          <div style={{ marginTop: 0 }}>
            <TablaReclamosTodos />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default Reclamos;
